import axios from '@/services/apiAxios'
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        controlAccounts: [],
    },
    mutations: {
        setControlAccounts(state, payload) {
            state.controlAccounts = payload;
        }
    }, 
    actions: {
        fetchControlAccounts({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.accounting.routePrefix}/account-controls?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setControlAccounts', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}